/**
 * Canonical lead status values (must match backend Lead.STATUS_CHOICES).
 */
import {
  Sparkles,
  Star,
  Ban,
  RefreshCw,
  CalendarCheck,
  Send,
  DoorOpen,
  Building2,
  CircleOff,
  Construction,
  Mail,
  CircleCheck,
  Lock,
  CircleX,
  ThumbsDown,
} from "lucide-react";

export const LEAD_STATUS_DEFINITIONS = [
  { value: "New", color: "#42A5F5", Icon: Sparkles, chipBg: "#E3F2FD" },
  { value: "Interested", color: "#39FF14", Icon: Star, chipBg: "#E4FFDC" },
  { value: "Not Interested", color: "#E53935", Icon: Ban, chipBg: "#FFEBEE" },
  { value: "Follow Up Needed", color: "#FB8C00", Icon: RefreshCw, chipBg: "#FFF3E0" },
  {
    value: "Appointment Scheduled",
    color: "#43A047",
    Icon: CalendarCheck,
    chipBg: "#E8F5E9",
  },
  {
    value: "Proposal Sent",
    color: "#1FF2EE",
    Icon: Send,
    chipBg: "#E0FFFE",
  },
  { value: "Not Home", color: "#8E24AA", Icon: DoorOpen, chipBg: "#F3E5F5" },
  { value: "Renter", color: "#5C6BC0", Icon: Building2, chipBg: "#E8EAF6" },
  {
    value: "Vacant Property",
    color: "#C2B280",
    Icon: CircleOff,
    chipBg: "#F5F0E6",
  },
  {
    value: "Under Construction",
    color: "#D817FF",
    Icon: Construction,
    chipBg: "#F3E5FF",
  },
  { value: "Left Flyer", color: "#808000", Icon: Mail, chipBg: "#F0F4E8" },
  { value: "Closed Won", color: "#4CAF50", Icon: CircleCheck, chipBg: "#E8F5E9" },
  { value: "Gated/No Access", color: "#5E0F00", Icon: Lock, chipBg: "#FFEBEE" },
  {
    value: "Competitor Installed",
    color: "#E53935",
    Icon: CircleX,
    chipBg: "#FFEBEE",
  },
  { value: "ADT Installed", color: "#B71C1C", Icon: ThumbsDown, chipBg: "#FFEBEE" },
];

export const LEAD_STATUS_VALUES = LEAD_STATUS_DEFINITIONS.map((d) => d.value);

/** Field disposition picker (excludes New — set at create). */
export const LEAD_STATUS_DISPOSITION_OPTIONS = LEAD_STATUS_DEFINITIONS.filter(
  (d) => d.value !== "New"
);

/** Quick map/route toggle statuses. */
export const LEAD_FIELD_QUICK_STATUS_VALUES = [
  "Not Home",
  "Not Interested",
  "Vacant Property",
  "Under Construction",
  "Left Flyer",
  "Renter",
  "Follow Up Needed",
  "Closed Won",
];

export function normalizeLeadStatusKey(status) {
  return (status || "New").trim().toLowerCase();
}

export function getLeadStatusDefinition(status) {
  const exact = LEAD_STATUS_DEFINITIONS.find((d) => d.value === status);
  if (exact) return exact;
  const key = normalizeLeadStatusKey(status);
  return (
    LEAD_STATUS_DEFINITIONS.find((d) => normalizeLeadStatusKey(d.value) === key) ||
    LEAD_STATUS_DEFINITIONS[0]
  );
}

export function getLeadStatusColor(status) {
  return getLeadStatusDefinition(status).color;
}

/** Map pin / filter chip colors keyed by normalized status label. */
export function buildLeadStatusColorMap() {
  const map = {};
  for (const d of LEAD_STATUS_DEFINITIONS) {
    map[normalizeLeadStatusKey(d.value)] = d.color;
  }
  return map;
}

export const LEAD_STATUS_CHIP_STYLES = LEAD_STATUS_DEFINITIONS.reduce((acc, d) => {
  acc[normalizeLeadStatusKey(d.value)] = {
    bg: d.chipBg,
    color: d.color,
  };
  return acc;
}, {});

export function getLeadStatusChipStyle(status) {
  return (
    LEAD_STATUS_CHIP_STYLES[normalizeLeadStatusKey(status)] ||
    LEAD_STATUS_CHIP_STYLES.new
  );
}
